import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { User } from "../../../models";
import { cloneDeep, isEqual } from "lodash-es";
import { CommonModule } from "@angular/common";
import { NgbDropdownModule } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'charla-assignee',
    templateUrl: 'assignee.component.html',
    styleUrls: ['assignee.component.scss'],
    imports: [CommonModule, ReactiveFormsModule, NgbDropdownModule]
})
  export class CharlaAssigneeComponent {

    @Input() agents: User[];
    @Input() selected: User[];
    @Input() debug: boolean = false;
    @Input() multiple: boolean = true;
    @Input() show_label: boolean = true;
    @Input() subtitle: string = "";
    @Output() public Save: EventEmitter<any> = new EventEmitter(); 
    checkboxGroup: FormGroup;
    filtered_agents: User[];
    initial_selection: User[];

    constructor(
        private fb: FormBuilder,
		private cd: ChangeDetectorRef
    ){

        this.checkboxGroup = this.fb.group({
            myValues: new FormArray([]),
            search: ''
          });
   
        

        this.checkboxGroup.get('search').valueChanges.subscribe(val => {
            if (val && val.length > 2){
                this.filtered_agents = this.agents.filter(ag => ag.fullname.toLowerCase().includes(val.toLowerCase()));
            } else {
                this.filtered_agents = this.agents;
            }
        });

    }

    ngOnInit(){

        this.update_filtered_agents();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.update_filtered_agents();
    }

    update_filtered_agents(){

        this.filtered_agents = this.agents;

        var selected_agents = this.selected;
        if (selected_agents){

            // reset form first, otherwise controls will be added twice on contact details save
            var myValues = (this.checkboxGroup.controls['myValues'] as FormArray);
            myValues.clear();

            // update the form
            selected_agents.forEach( (user) => {
                this.update_form(true, user.id)
            });   

        } 


    }

    is_selected(agent_id: string){
        return this.selected?.find(t => t.id == agent_id);
    }

    openChange(isOpened){
        if (!isOpened) {
            
            if ( this.selected.length > 0 ){

                if ( !(isEqual(this.selected, this.initial_selection))) {
                    this.Save.emit( this.selected );
                }

            } else {
                // nothing was selected revert to initial selection
                this.selected = this.initial_selection;
            }

        } else {
            // store initial selection, needed later to revert to it if user
            // didnt select something
            this.initial_selection  = cloneDeep(this.selected);
        }
    }

    onCheckboxChange(event: any) {
            
        if (this.multiple) {
            this.update_form(event.target.checked, event.target.value);
        } else {
            // Single selection mode - clear all and add only the selected one
            const myValues = (this.checkboxGroup.controls['myValues'] as FormArray);
            myValues.clear();
            myValues.push(new FormControl(event.target.value));
        }

        this.update_selected();

    }

    onSingleSelect(agentId: string) {

        this.Save.emit([{id:agentId}]);
    }

    update_form(is_checked: boolean, value: string){

        const myValues = (this.checkboxGroup.controls['myValues'] as FormArray);

        if (is_checked) {
            myValues.push(new FormControl(value));

          } else {
            const index = myValues.controls
            .findIndex(x => x.value === value);
            myValues.removeAt(index);
  
          }

    }

    update_selected(){

        const myValues = (this.checkboxGroup.controls['myValues'] as FormArray);

        this.selected = [];
        for (let control of myValues.controls) {
            const t = this.agents.find(t => t.id == control.value);
            this.selected.push(t);
        }
    }


  }
    